import React from 'react';
import { ChevronDown, ChevronRight, Plus } from 'lucide-react';
import Tooltip from '../ui/Tooltip';
import { listBadgeTone } from '../../extensions/bundled/task-manager/boardProgress';
import { GroupTitle, GroupHeaderMenu } from './GroupHeader';
import ColumnProgress from './ColumnProgress';
import './ColumnHeader.css';
import './ListSectionHeader.css';

const stop = (e) => e.stopPropagation();

/** The 44 px header of a List view section (Boards Redesign card 6.1):
 *  collapse chevron · numbered tint badge (same tones as the Kanban column,
 *  card 3.1) · list name (click to rename) · done/total pill · progress bar
 *  with "N open" (ColumnProgress, shared with the column header) · Add task ·
 *  ⋯. The header is the section's drag handle; its buttons stop the pointer
 *  so clicking them never starts a drag. */
export default function ListSectionHeader({ group, index = 0, progress, showProgress = true, collapsed = false, onToggleCollapsed, editing, setEditing, onRename, onDelete, onAddTask, dragHandleProps }) {
  const { done = 0, total = 0 } = progress || {};
  const tone = listBadgeTone(index);
  const name = group.name || 'Unnamed list';
  return (
    <div className="task-board-column-header task-board-list-section-header" {...dragHandleProps}>
      <Tooltip content={collapsed ? 'Expand list' : 'Collapse list'} side="top">
        <button
          type="button"
          className="task-board-list-collapse"
          aria-label={collapsed ? `Expand ${name}` : `Collapse ${name}`}
          aria-expanded={!collapsed}
          onPointerDown={stop}
          onClick={(e) => {
            e.stopPropagation();
            onToggleCollapsed?.();
          }}
        >
          {collapsed ? <ChevronRight size={13} aria-hidden /> : <ChevronDown size={13} aria-hidden />}
        </button>
      </Tooltip>
      <span className={`task-board-col-badge task-board-col-badge--${tone}`} aria-hidden="true">
        {index + 1}
      </span>
      <GroupTitle group={group} editing={editing} setEditing={setEditing} onRename={onRename} />
      <Tooltip content={`${done} of ${total} done`} side="bottom">
        <span className="task-board-col-pill" aria-label={`${done} of ${total} done`}>
          {done}/{total}
        </span>
      </Tooltip>
      {showProgress && <ColumnProgress progress={progress} className="task-board-list-section-progress" />}
      <span className="task-board-list-section-spacer" />
      <button
        type="button"
        className="task-board-list-add-task"
        onPointerDown={stop}
        onClick={(e) => {
          e.stopPropagation();
          onAddTask?.();
        }}
      >
        <Plus size={12} aria-hidden /> Add task
      </button>
      <GroupHeaderMenu onRename={() => setEditing(true)} onDelete={onDelete} />
    </div>
  );
}
